/**
 *
 * @version 12.4.0 #756 MLIBJS-121 Export wd-helpers as a node module
 * 
 * @author Erik Orozco <eorozco@intersog.com>
 * 
 * @copyright (c) 2020 Build Centrix.
 *
 */

globalThis.jsSHA = require('jssha');
globalThis.toastr = require('toastr');
globalThis.humanizeDuration = require('humanize-duration');

globalThis.HumanizeDurationMomentAdapter = require('../../es6/helpers/DateTimeHelper/adapters/HumanizeDurationMomentAdapter').default;
globalThis.DateTimeHelperMomentAdapter = require('../../es6/helpers/DateTimeHelper/adapters/DateTimeHelperMomentAdapter').default;
globalThis.DateTimeHelper = require('../../es6/helpers/DateTimeHelper/DateTimeHelper').default;

require('../../webduct/hash/AdapterHash');
require('../../webduct/order/AdapterOrder');
require('../../webduct/order/AdapterOrderStatus');
require('../../webduct/order/AdapterFulfillmentGroup');

var wdDatePickerHelper = require('./wdDatePickerHelper');
var wdDateTimeHelper = require('./wdDateTimeHelper');
var wdFulfillmentGroupHelper = require('./wdFulfillmentGroupHelper');
var wdHashHelper = require('./wdHashHelper');
var wdOrderHelper = require('./wdOrderHelper');
var wdOrderStatusHelper = require('./wdOrderStatusHelper');
var wdToastrHandler = require('./wdToastrHandler');


module.exports = {
    wdDatePickerHelper: wdDatePickerHelper.name,
    wdDateTimeHelper: wdDateTimeHelper.name,
    wdFulfillmentGroupHelper: wdFulfillmentGroupHelper.name,
    wdHashHelper: wdHashHelper.name,
    wdOrderHelper: wdOrderHelper.name,
    wdOrderStatusHelper: wdOrderStatusHelper.name,
    wdToastrHandler: wdToastrHandler.name
};

// EOF